export default "__VITE_ASSET__o_dhoHdy__"